import Vue from 'vue';
import ModulesHelper from '@core/services/modules.helper';
import AuthorizationHelper from '@auth/services/authorization.helper';
import { Component } from 'vue-property-decorator';

@Component({
  components: {},
})
export default class CenterSidebarEntriesMixin extends Vue {
  declare hideMenuItem: boolean;
  declare hideTrueCostSidebar: boolean;
  declare hideAnalyticsSidebar: boolean;
  declare hideSepaSidebar: boolean;
  declare hideAccessPointsSidebar: boolean;
  declare hideTppwbSideBar: boolean;

  get centerMenuEntriesTabs() {
    return ['main', 'communication', 'configuration'];
  }

  get centerMainMenuEntries() {
    return [
      {
        header: true,
        title: this.$t('global.sidebar_menu.main_menu.dashboard'),
        hidden: this.hideMenuItem,
      },
      {
        href: this.$clientRouter.getClientUrl(`admin/coming-soon`),
        icon: 'pe-7s-home',
        title: this.$t('global.sidebar_menu.main_menu.dashboard'),
        hidden: this.hideMenuItem,
        exactPath: true,
      },
      {
        header: true,
        title: this.$t('global.sidebar_menu.main_menu.contacts_management'),
        modules: [
          ModulesHelper.CONTACTS_MODULE_NAME,
          ModulesHelper.SUBSCRIPTIONS_MODULE_NAME,
          ModulesHelper.CONTRACTS_DOCUMENTS_MODULE_NAME,
          ModulesHelper.CERTIFICATES_MODULE_NAME,
          ModulesHelper.ENTRIES_MODULE_NAME,
        ],
        permissions: ['sidebar_contact_section'],
      },
      {
        href: this.$clientRouter.getClientUrl(`admin/main/contacts`),
        title: this.$t('global.sidebar_menu.main_menu.contacts'),
        icon: 'pe-7s-user',
        exactPath: true,
        permissions: [AuthorizationHelper.fixedPermissions.sidebar.contacts],
        module: ModulesHelper.CONTACTS_MODULE_NAME,
      },
      {
        href: this.$clientRouter.getClientUrl(`admin/coming-soon`),
        title: this.$t('global.sidebar_menu.main_menu.memberships'),
        hidden: this.hideMenuItem,
        icon: 'pe-7s-id',
        exactPath: true,
      },
      {
        href: this.$clientRouter.getClientUrl(`admin/main/access-control-badge`),
        title: this.$t('global.sidebar_menu.main_menu.access_control_badge'),
        icon: 'pe-7s-target',
        exactPath: true,
        permissions: [AuthorizationHelper.fixedPermissions.sidebar.access_control_badges],
        module: ModulesHelper.ACCESS_CONTROL_MODULE_NAME,
      },
      {
        href: this.$clientRouter.getClientUrl(`admin/main/entries`),
        title: this.$t('global.sidebar_menu.main_menu.entries'),
        icon: 'pe-7s-way',
        exactPath: true,
        permissions: [AuthorizationHelper.fixedPermissions.sidebar.entries],
        module: ModulesHelper.ENTRIES_MODULE_NAME,
      },
      {
        href: this.$clientRouter.getClientUrl(`admin/main/certificates`),
        title: this.$t('global.sidebar_menu.main_menu.certificates'),
        icon: 'pe-7s-paperclip',
        exactPath: true,
        permissions: [AuthorizationHelper.fixedPermissions.sidebar.certificates],
        module: ModulesHelper.CERTIFICATES_MODULE_NAME,
      },
      {
        href: this.$clientRouter.getClientUrl(`admin/main/contracts`),
        title: this.$t('global.sidebar_menu.main_menu.contracts'),
        icon: 'pe-7s-note2',
        exactPath: true,
        permissions: [AuthorizationHelper.fixedPermissions.sidebar.contracts],
        module: ModulesHelper.CONTRACTS_DOCUMENTS_MODULE_NAME,
      },
      {
        href: this.$clientRouter.getClientUrl(`admin/main/documents`),
        title: this.$t('global.sidebar_menu.main_menu.documents'),
        icon: 'pe-7s-albums',
        exactPath: true,
        permissions: [AuthorizationHelper.fixedPermissions.sidebar.documents],
        module: ModulesHelper.CONTRACTS_DOCUMENTS_MODULE_NAME,
      },
      {
        href: this.$clientRouter.getClientUrl(`admin/main/contacts-tppwb`),
        title: this.$t('global.sidebar_menu.main_menu.contacts_tppwb'),
        icon: 'pe-7s-refresh-2',
        exactPath: true,
        permissions: [AuthorizationHelper.fixedPermissions.sidebar.contacts],
        module: ModulesHelper.TPPWB_SYNC_MODULE_NAME,
        hidden: this.hideTppwbSideBar,
      },
      // Memberships & Subscriptions
      {
        header: true,
        title: this.$t('global.sidebar_menu.main_menu.subscriptions_management'),
        modules: [ModulesHelper.SUBSCRIPTIONS_MODULE_NAME],
        permissions: ['sidebar_subscription_section'],
      },
      {
        href: this.$clientRouter.getClientUrl(`admin/main/subscriptions/catalog`),
        title: this.$t('global.sidebar_menu.main_menu.subscription_categories'),
        icon: 'pe-7s-albums',
        exactPath: true,
        permissions: [AuthorizationHelper.fixedPermissions.sidebar.subscription_categories],
        module: ModulesHelper.SUBSCRIPTIONS_MODULE_NAME,
      },
      {
        href: this.$clientRouter.getClientUrl(`admin/main/subscriptions/subscriptions`),
        title: this.$t('global.sidebar_menu.main_menu.subscriptions'),
        icon: 'pe-7s-id',
        exactPath: true,
        permissions: [AuthorizationHelper.fixedPermissions.sidebar.subscriptions],
        module: ModulesHelper.SUBSCRIPTIONS_MODULE_NAME,
      },
      {
        href: this.$clientRouter.getClientUrl(`admin/main/subscriptions/payments-follow-up`),
        title: this.$t('global.sidebar_menu.main_menu.subscriptions_payments_follow_up'),
        icon: 'pe-7s-cash',
        exactPath: true,
        permissions: [AuthorizationHelper.fixedPermissions.sidebar.subscriptions],
        module: ModulesHelper.SUBSCRIPTIONS_MODULE_NAME,
      },
      {
        href: this.$clientRouter.getClientUrl(`admin/main/subscriptions/direct-debits-follow-up`),
        title: this.$t('global.sidebar_menu.main_menu.subscriptions_direct_debits_follow_up'),
        icon: 'pe-7s-repeat',
        exactPath: true,
        hidden: this.hideSepaSidebar,
        permissions: [AuthorizationHelper.fixedPermissions.sidebar.direct_debit_files],
        module: ModulesHelper.SUBSCRIPTIONS_MODULE_NAME,
      },
      // Bookings
      {
        header: true,
        title: this.$t('global.sidebar_menu.main_menu.bookings_management'),
        module: ModulesHelper.BOOKINGS_MODULE_NAME,
        permissions: ['sidebar_booking_section'],
      },
      {
        href: this.$clientRouter.getClientUrl(`admin/main/daily`),
        title: this.$t('global.sidebar_menu.main_menu.daily'),
        icon: 'pe-7s-bookmarks',
        exactPath: true,
        permissions: [AuthorizationHelper.fixedPermissions.sidebar.booking_events],
        module: ModulesHelper.BOOKINGS_MODULE_NAME,
      },
      {
        href: this.$clientRouter.getClientUrl(`admin/main/booking-events`),
        title: this.$t('global.sidebar_menu.main_menu.events'),
        icon: 'pe-7s-bookmarks',
        exactPath: true,
        permissions: [AuthorizationHelper.fixedPermissions.sidebar.booking_events],
        module: ModulesHelper.BOOKINGS_MODULE_NAME,
      },
      {
        href: this.$clientRouter.getClientUrl(`admin/main/calendar`),
        title: this.$t('global.sidebar_menu.main_menu.calendars'),
        // hidden: this.hideMenuItem,
        icon: 'pe-7s-date',
        exactPath: true,
        permissions: [
          { name: AuthorizationHelper.fixedPermissions.sidebar.booking_events_calendar },
        ],
        module: ModulesHelper.BOOKINGS_MODULE_NAME,
      },
      {
        href: this.$clientRouter.getClientUrl(`admin/main/bookings`),
        title: this.$t('global.sidebar_menu.main_menu.bookings'),
        icon: 'pe-7s-notebook',
        exactPath: true,
        permissions: [AuthorizationHelper.fixedPermissions.sidebar.bookings],
        module: ModulesHelper.BOOKINGS_MODULE_NAME,
      },
      {
        href: this.$clientRouter.getClientUrl(`admin/main/booking-events/payments-follow-up`),
        title: this.$t('global.sidebar_menu.main_menu.bookings_payments_follow_up'),
        icon: 'pe-7s-cash',
        exactPath: true,
        permissions: [AuthorizationHelper.fixedPermissions.sidebar.bookings],
        module: ModulesHelper.BOOKINGS_MODULE_NAME,
      },
      {
        header: true,
        title: this.$t('global.sidebar_menu.main_menu.activities_management'),
        module: ModulesHelper.ACTIVITIES_MODULE_NAME,
        permissions: ['sidebar_activity_section'],
      },
      {
        href: this.$clientRouter.getClientUrl(`admin/main/activities`),
        title: this.$t('global.sidebar_menu.main_menu.activities'),
        icon: 'pe-7s-ball',
        exactPath: true,
        permissions: [AuthorizationHelper.fixedPermissions.sidebar.activities],
        module: ModulesHelper.ACTIVITIES_MODULE_NAME,
      },
      {
        href: this.$clientRouter.getClientUrl(`admin/main/activity-groups`),
        title: this.$t('global.sidebar_menu.main_menu.groups'),
        icon: 'pe-7s-users',
        exactPath: true,
        permissions: [AuthorizationHelper.fixedPermissions.sidebar.activity_groups],
        module: ModulesHelper.ACTIVITIES_MODULE_NAME,
      },
      {
        href: this.$clientRouter.getClientUrl(`admin/main/activity-sessions`),
        title: this.$t('global.sidebar_menu.main_menu.activity_sessions'),
        icon: 'pe-7s-gym',
        exactPath: true,
        permissions: [AuthorizationHelper.fixedPermissions.sidebar.activity_sessions],
        module: ModulesHelper.ACTIVITIES_MODULE_NAME,
      },
      {
        href: this.$clientRouter.getClientUrl(
          `admin/main/activity-session-attendees/activity-session-attendees`,
        ),
        title: this.$t('global.sidebar_menu.main_menu.activity_session_attendees'),
        icon: 'pe-7s-study',
        exactPath: true,
        permissions: [AuthorizationHelper.fixedPermissions.sidebar.activity_session_attendees],
        module: ModulesHelper.ACTIVITIES_MODULE_NAME,
      },
      {
        href: this.$clientRouter.getClientUrl(`admin/main/enrollments/enrollments`),
        title: this.$t('global.sidebar_menu.main_menu.enrollments'),
        icon: 'pe-7s-ticket',
        exactPath: true,
        permissions: [AuthorizationHelper.fixedPermissions.sidebar.enrollments],
        module: ModulesHelper.ACTIVITIES_MODULE_NAME,
      },
      {
        href: this.$clientRouter.getClientUrl(`admin/main/enrollments/payments-follow-up`),
        title: this.$t('global.sidebar_menu.main_menu.enrollments_payments_follow_up_page'),
        icon: 'pe-7s-cash',
        exactPath: true,
        permissions: [AuthorizationHelper.fixedPermissions.sidebar.enrollments],
        module: ModulesHelper.ACTIVITIES_MODULE_NAME,
      },
      {
        href: this.$clientRouter.getClientUrl(`admin/main/activity-certificates`),
        title: this.$t('global.sidebar_menu.main_menu.activity_certificates'),
        icon: 'pe-7s-paperclip',
        exactPath: true,
        permissions: [AuthorizationHelper.fixedPermissions.sidebar.tax_certificates],
        module: ModulesHelper.TAX_CERTIFICATES_MODULE_NAME,
      },
      {
        header: true,
        title: this.$t('global.sidebar_menu.main_menu.domotic_management'),
        hidden: this.hideMenuItem,
        permissions: ['sidebar_domotic_section'],
      },
      {
        href: this.$clientRouter.getClientUrl(`admin/coming-soon`),
        title: this.$t('global.sidebar_menu.main_menu.access'),
        hidden: this.hideMenuItem,
        icon: 'pe-7s-upload',
        exactPath: true,
      },
      {
        href: this.$clientRouter.getClientUrl(`admin/coming-soon`),
        title: this.$t('global.sidebar_menu.main_menu.lightning'),
        hidden: this.hideMenuItem,
        icon: 'pe-7s-light',
        exactPath: true,
      },
      {
        href: this.$clientRouter.getClientUrl(`admin/coming-soon`),
        title: this.$t('global.sidebar_menu.main_menu.heating'),
        hidden: this.hideMenuItem,
        icon: 'pe-7s-sun',
        exactPath: true,
      },
      {
        header: true,
        title: this.$t('global.sidebar_menu.main_menu.point_of_sale'),
        modules: [ModulesHelper.POS_MODULE_NAME],
        permissions: ['sidebar_point_of_sale_section'],
      },
      {
        href: this.$clientRouter.getClientUrl(`admin/main/pos-articles`),
        title: this.$t('global.sidebar_menu.main_menu.pos_articles'),
        icon: 'pe-7s-keypad',
        exactPath: true,
        permissions: [AuthorizationHelper.fixedPermissions.sidebar.articles],
        module: ModulesHelper.POS_MODULE_NAME,
      },
      {
        href: this.$clientRouter.getClientUrl(`admin/main/pos-sessions`),
        title: this.$t('global.sidebar_menu.main_menu.pos_sessions'),
        icon: 'pe-7s-calculator',
        exactPath: true,
        permissions: [AuthorizationHelper.fixedPermissions.sidebar.pos_sessions],
        module: ModulesHelper.POS_MODULE_NAME,
      },
      {
        href: this.$clientRouter.getClientUrl(`admin/main/sync-console`),
        title: this.$t('global.sidebar_menu.main_menu.sync_console'),
        icon: 'pe-7s-refresh-2',
        exactPath: true,
        permissions: [AuthorizationHelper.fixedPermissions.sidebar.pos_sessions],
        module: ModulesHelper.ACCOUNTING_INTEGRATIONS_MODULE_NAME,
      },
      {
        href: this.$clientRouter.getClientUrl(`admin/main/pos-incidents`),
        title: this.$t('global.sidebar_menu.main_menu.pos_incidents'),
        icon: 'pe-7s-attention',
        exactPath: true,
        permissions: [AuthorizationHelper.fixedPermissions.sidebar.pos_incidents],
        module: ModulesHelper.POS_MODULE_NAME,
      },
      {
        header: true,
        title: this.$t('global.sidebar_menu.main_menu.accounting'),
        module: ModulesHelper.ACCOUNTING_MODULE_NAME,
        permissions: ['sidebar_accounting_section'],
      },
      {
        href: this.$clientRouter.getClientUrl(`admin/main/orders`),
        title: this.$t('global.sidebar_menu.main_menu.orders'),
        icon: 'pe-7s-cart',
        exactPath: true,
        permissions: [AuthorizationHelper.fixedPermissions.sidebar.orders],
        module: ModulesHelper.ACCOUNTING_MODULE_NAME,
      },
      {
        href: this.$clientRouter.getClientUrl(`admin/main/orders/items`),
        title: this.$t('global.sidebar_menu.main_menu.order_items'),
        icon: 'pe-7s-menu',
        exactPath: true,
        permissions: [AuthorizationHelper.fixedPermissions.sidebar.orders],
        module: ModulesHelper.ACCOUNTING_MODULE_NAME,
      },
      {
        href: this.$clientRouter.getClientUrl(`admin/main/invoices/to-pay`),
        title: this.$t('global.sidebar_menu.main_menu.invoices'),
        icon: 'pe-7s-next-2',
        exactPath: true,
        permissions: [AuthorizationHelper.fixedPermissions.sidebar.invoices],
        module: ModulesHelper.ACCOUNTING_MODULE_NAME,
      },
      {
        href: this.$clientRouter.getClientUrl(`admin/main/credit-notes/to-pay`),
        title: this.$t('global.sidebar_menu.main_menu.credit_notes'),
        icon: 'pe-7s-back-2',
        exactPath: true,
        permissions: [AuthorizationHelper.fixedPermissions.sidebar.invoices],
        module: ModulesHelper.ACCOUNTING_MODULE_NAME,
      },
      {
        href: this.$clientRouter.getClientUrl(`admin/main/wallets`),
        title: this.$t('global.sidebar_menu.main_menu.wallets'),
        icon: 'pe-7s-wallet',
        exactPath: true,
        permissions: [AuthorizationHelper.fixedPermissions.sidebar.wallets],
        module: ModulesHelper.VIRTUAL_WALLET_MODULE_NAME,
      },
      {
        href: this.$clientRouter.getClientUrl(`admin/main/tickets`),
        title: this.$t('global.sidebar_menu.main_menu.tickets'),
        icon: 'pe-7s-news-paper',
        exactPath: true,
        permissions: [AuthorizationHelper.fixedPermissions.sidebar.tickets],
        module: ModulesHelper.ACCOUNTING_MODULE_NAME,
      },
      {
        href: this.$clientRouter.getClientUrl(`admin/main/codas`),
        title: this.$t('global.sidebar_menu.main_menu.codas'),
        icon: 'pe-7s-news-paper',
        exactPath: true,
        permissions: [AuthorizationHelper.fixedPermissions.sidebar.codas],
        module: ModulesHelper.CODA_MANAGEMENT_MODULE_NAME,
      },
      {
        href: this.$clientRouter.getClientUrl(`admin/main/coda-transactions`),
        title: this.$t('global.sidebar_menu.main_menu.coda_transactions'),
        icon: 'pe-7s-news-paper',
        exactPath: true,
        permissions: [AuthorizationHelper.fixedPermissions.sidebar.codas],
        module: ModulesHelper.CODA_MANAGEMENT_MODULE_NAME,
      },
      {
        href: this.$clientRouter.getClientUrl(`admin/main/payments`),
        title: this.$t('global.sidebar_menu.main_menu.payments'),
        icon: 'pe-7s-credit',
        exactPath: true,
        permissions: [AuthorizationHelper.fixedPermissions.sidebar.payments],
        module: ModulesHelper.ACCOUNTING_MODULE_NAME,
      },
      {
        href: this.$clientRouter.getClientUrl(`admin/main/invoice-sync-items`),
        title: this.$t('global.sidebar_menu.main_menu.invoice_sync_items'),
        icon: 'pe-7s-cloud-upload',
        exactPath: true,
        permissions: [AuthorizationHelper.fixedPermissions.sidebar.invoice_sync_items],
        module: ModulesHelper.ACCOUNTING_INTEGRATIONS_MODULE_NAME,
      },
      {
        href: this.$clientRouter.getClientUrl(`admin/main/coupons`),
        title: this.$t('global.sidebar_menu.main_menu.coupons'),
        icon: 'pe-7s-gift',
        exactPath: true,
        permissions: [AuthorizationHelper.fixedPermissions.sidebar.coupons],
        module: ModulesHelper.ACCOUNTING_MODULE_NAME,
      },
      {
        href: this.$clientRouter.getClientUrl(`admin/coming-soon`),
        title: this.$t('global.sidebar_menu.main_menu.accounts'),
        hidden: this.hideMenuItem,
        icon: 'pe-7s-notebook',
        exactPath: true,
      },
      {
        header: true,
        title: this.$t('global.sidebar_menu.main_menu.monitoring'),
        permissions: ['sidebar_monitoring_section'],
      },
      {
        href: this.$clientRouter.getClientUrl(`admin/coming-soon`),
        title: this.$t('global.sidebar_menu.main_menu.statistics'),
        hidden: this.hideMenuItem,
        icon: 'pe-7s-graph2',
        exactPath: true,
      },
      {
        href: this.$clientRouter.getClientUrl(`admin/coming-soon`),
        title: this.$t('global.sidebar_menu.main_menu.reporting'),
        hidden: this.hideMenuItem,
        icon: 'pe-7s-note2',
        exactPath: true,
      },
      {
        href: this.$clientRouter.getClientUrl(`admin/main/access-control-events`),
        title: this.$t('global.sidebar_menu.main_menu.access_control_events'),
        icon: 'pe-7s-way',
        exactPath: true,
        permissions: [AuthorizationHelper.fixedPermissions.sidebar.access_control_events],
        module: ModulesHelper.ACCESS_CONTROL_MODULE_NAME,
      },
      {
        href: this.$clientRouter.getClientUrl(`admin/main/accesses-report`),
        title: this.$t('global.sidebar_menu.main_menu.accesses_report'),
        icon: 'pe-7s-graph3',
        exactPath: true,
        permissions: [AuthorizationHelper.fixedPermissions.sidebar.accesses_report],
        module: ModulesHelper.ACCESS_CONTROL_MODULE_NAME,
      },
      {
        href: this.$clientRouter.getClientUrl(`admin/main/sales-report`),
        title: this.$t('global.sidebar_menu.main_menu.sales_report'),
        icon: 'pe-7s-cash',
        exactPath: true,
        permissions: [AuthorizationHelper.fixedPermissions.sidebar.sales_report],
        module: ModulesHelper.ACCOUNTING_MODULE_NAME,
      },
      {
        href: this.$clientRouter.getClientUrl(`admin/main/accounting-reports`),
        title: this.$t('global.sidebar_menu.main_menu.accounting_reports'),
        icon: 'pe-7s-graph2',
        exactPath: true,
        permissions: [AuthorizationHelper.fixedPermissions.sidebar.accounting_reports],
        module: ModulesHelper.ACCOUNTING_MODULE_NAME,
      },
      {
        href: this.$clientRouter.getClientUrl(`admin/main/user-evolution`),
        title: this.$t('global.sidebar_menu.main_menu.user_evolution'),
        icon: 'pe-7s-user',
        exactPath: true,
        permissions: [AuthorizationHelper.fixedPermissions.sidebar.contacts],
        module: ModulesHelper.CONTACTS_MODULE_NAME,
      },
    ];
  }

  get centerCommunicationMenuEntries() {
    return [
      {
        header: true,
        title: this.$t('global.sidebar_menu.communication_menu.communication'),
        permissions: [AuthorizationHelper.fixedPermissions.sidebar.messages],
        module: ModulesHelper.COMMUNICATIONS_MODULE_NAME,
      },
      {
        href: this.$clientRouter.getClientUrl(`admin/communication/mailbox`),
        title: this.$t('global.sidebar_menu.communication_menu.inbox'),
        icon: 'pe-7s-comment',
        exactPath: true,
        permissions: [AuthorizationHelper.fixedPermissions.sidebar.messages],
        module: ModulesHelper.COMMUNICATIONS_MODULE_NAME,
      },
      {
        href: this.$clientRouter.getClientUrl(`admin/coming-soon`),
        title: this.$t('global.sidebar_menu.communication_menu.chat'),
        hidden: this.hideMenuItem,
        icon: 'pe-7s-chat',
        exactPath: true,
      },
      {
        href: this.$clientRouter.getClientUrl(`admin/coming-soon`),
        title: this.$t('global.sidebar_menu.communication_menu.mailing_list'),
        hidden: this.hideMenuItem,
        icon: 'pe-7s-speaker',
        exactPath: true,
      },
      {
        href: this.$clientRouter.getClientUrl(`admin/coming-soon`),
        title: this.$t('global.sidebar_menu.communication_menu.newsletters'),
        hidden: this.hideMenuItem,
        icon: 'pe-7s-mail-open-file',
        exactPath: true,
      },
      {
        href: this.$clientRouter.getClientUrl(`admin/configuration/post-categories`),
        title: this.$t('global.sidebar_menu.configuration_menu.post_categories'),
        icon: 'pe-7s-folder',
        exactPath: true,
        permissions: [AuthorizationHelper.fixedPermissions.sidebar.post_categories],
        module: ModulesHelper.CMS_MODULE_NAME,
      },
      {
        href: this.$clientRouter.getClientUrl(`admin/communication/posts`),
        title: this.$t('global.sidebar_menu.communication_menu.posts'),
        icon: 'pe-7s-news-paper',
        exactPath: true,
        permissions: [AuthorizationHelper.fixedPermissions.sidebar.posts],
        module: ModulesHelper.CMS_MODULE_NAME,
      },
      {
        href: this.$clientRouter.getClientUrl(`admin/communication/post-online-training`),
        title: this.$t('global.sidebar_menu.communication_menu.online-training'),
        icon: 'pe-7s-display1',
        exactPath: true,
        permissions: [AuthorizationHelper.fixedPermissions.sidebar.posts],
        module: ModulesHelper.CMS_MODULE_NAME,
      },
      {
        header: true,
        title: this.$t('global.sidebar_menu.communication_menu.website'),
        permissions: [AuthorizationHelper.fixedPermissions.sidebar.posts],
        module: ModulesHelper.CMS_MODULE_NAME,
      },
      {
        header: true,
        title: this.$t('global.sidebar_menu.communication_menu.website'),
        hidden: this.hideMenuItem,
        permissions: ['sidebar_website_section'],
        module: ModulesHelper.CMS_MODULE_NAME,
      },
      {
        href: this.$clientRouter.getClientUrl(`admin/communication/menu-entries`),
        title: this.$t('global.sidebar_menu.communication_menu.menu'),
        icon: 'pe-7s-network',
        exactPath: true,
        permissions: [AuthorizationHelper.fixedPermissions.sidebar.menu_entries],
        module: ModulesHelper.CMS_MODULE_NAME,
      },
      {
        href: this.$clientRouter.getClientUrl(`admin/communication/post-pages`),
        title: this.$t('global.sidebar_menu.communication_menu.pages'),
        icon: 'pe-7s-photo-gallery',
        exactPath: true,
        permissions: [AuthorizationHelper.fixedPermissions.sidebar.posts],
        module: ModulesHelper.CMS_MODULE_NAME,
      },
      {
        href: this.$clientRouter.getClientUrl(`admin/coming-soon`),
        title: this.$t('global.sidebar_menu.communication_menu.pages'),
        hidden: this.hideMenuItem,
        icon: 'pe-7s-copy-file',
        exactPath: true,
      },
      {
        href: this.$clientRouter.getClientUrl(`admin/coming-soon`),
        title: this.$t('global.sidebar_menu.communication_menu.themes'),
        hidden: this.hideMenuItem,
        icon: 'pe-7s-look',
        exactPath: true,
      },
      {
        href: this.$clientRouter.getClientUrl(`admin/communication/widgets`),
        title: this.$t('global.sidebar_menu.communication_menu.widgets'),
        icon: 'pe-7s-plugin',
        exactPath: true,
        permissions: [AuthorizationHelper.fixedPermissions.sidebar.widgets],
        module: ModulesHelper.CMS_MODULE_NAME,
      },
      {
        header: true,
        title: this.$t('global.sidebar_menu.communication_menu.library'),
        hidden: this.hideMenuItem,
        permissions: ['sidebar_library_section'],
      },
      {
        href: this.$clientRouter.getClientUrl(`admin/coming-soon`),
        title: this.$t('global.sidebar_menu.communication_menu.medias'),
        hidden: this.hideMenuItem,
        icon: 'pe-7s-photo',
        exactPath: true,
      },
      {
        href: this.$clientRouter.getClientUrl(`admin/coming-soon`),
        title: this.$t('global.sidebar_menu.communication_menu.albums'),
        hidden: this.hideMenuItem,
        icon: 'pe-7s-photo-gallery',
        exactPath: true,
      },
    ];
  }

  get centerConfigurationMenuEntries() {
    return [
      {
        header: true,
        title: this.$t('global.sidebar_menu.configuration_menu.basic_configuration'),
        permissions: ['sidebar_basic_configuration_section'],
      },
      {
        href: this.$clientRouter.getClientUrl(`admin/configuration/disciplines`),
        title: this.$t('global.sidebar_menu.configuration_menu.disciplines'),
        icon: 'pe-7s-ball',
        exactPath: true,
        permissions: [AuthorizationHelper.fixedPermissions.sidebar.disciplines],
      },
      {
        href: this.$clientRouter.getClientUrl(`admin/configuration/resources`),
        title: this.$t('global.sidebar_menu.configuration_menu.resources'),
        icon: 'pe-7s-culture',
        exactPath: true,
        permissions: [AuthorizationHelper.fixedPermissions.sidebar.resources],
      },
      {
        href: this.$clientRouter.getClientUrl(`admin/configuration/sectors`),
        title: this.$t('global.sidebar_menu.configuration_menu.sectors'),
        icon: 'pe-7s-network',
        exactPath: true,
        permissions: [AuthorizationHelper.fixedPermissions.sidebar.sectors],
        module: ModulesHelper.BOOKINGS_MODULE_NAME,
      },
      {
        href: this.$clientRouter.getClientUrl(`admin/main/entry-categories`),
        title: this.$t('global.sidebar_menu.main_menu.entry_categories'),
        icon: 'pe-7s-way',
        exactPath: true,
        permissions: [AuthorizationHelper.fixedPermissions.sidebar.entry_categories],
        module: ModulesHelper.ENTRIES_MODULE_NAME,
      },
      {
        href: this.$clientRouter.getClientUrl(`admin/configuration/periods`),
        title: this.$t('global.sidebar_menu.configuration_menu.periods'),
        icon: 'pe-7s-date',
        exactPath: true,
        permissions: [AuthorizationHelper.fixedPermissions.sidebar.periods],
        module: ModulesHelper.BOOKINGS_MODULE_NAME,
      },
      {
        href: this.$clientRouter.getClientUrl(`admin/configuration/profiles`),
        title: this.$t('global.sidebar_menu.main_menu.users'),
        icon: 'pe-7s-users',
        exactPath: true,
        permissions: [AuthorizationHelper.fixedPermissions.sidebar.profiles],
      },
      {
        header: true,
        title: this.$t('global.sidebar_menu.configuration_menu.accounting_configuration'),
        permissions: ['sidebar_accounting_configuration_section'],
      },
      {
        href: this.$clientRouter.getClientUrl(`admin/configuration/articles`),
        title: this.$t('global.sidebar_menu.configuration_menu.articles'),
        icon: 'pe-7s-drawer',
        exactPath: true,
        permissions: [AuthorizationHelper.fixedPermissions.sidebar.articles],
        module: ModulesHelper.ACCOUNTING_MODULE_NAME,
      },
      {
        href: this.$clientRouter.getClientUrl(`admin/configuration/discount-categories`),
        title: this.$t('global.sidebar_menu.configuration_menu.discount-categories'),
        icon: 'pe-7s-drawer',
        exactPath: true,
        permissions: [AuthorizationHelper.fixedPermissions.sidebar.discount_categories],
        module: ModulesHelper.ACCOUNTING_MODULE_NAME,
      },
      {
        href: this.$clientRouter.getClientUrl(`admin/configuration/article-true-costs`),
        title: this.$t('global.sidebar_menu.configuration_menu.article-true-costs'),
        hidden: this.hideTrueCostSidebar,
        icon: 'pe-7s-drawer',
        exactPath: true,
        permissions: [AuthorizationHelper.fixedPermissions.sidebar.article_true_costs],
        module: ModulesHelper.SUBVENTIONS_MODULE_NAME,
      },
      {
        href: this.$clientRouter.getClientUrl(`admin/configuration/taxes`),
        title: this.$t('global.sidebar_menu.configuration_menu.taxes'),
        icon: 'pe-7s-piggy',
        exactPath: true,
        permissions: [AuthorizationHelper.fixedPermissions.sidebar.taxes],
        module: ModulesHelper.ACCOUNTING_MODULE_NAME,
      },
      {
        href: this.$clientRouter.getClientUrl(`admin/configuration/accounting-journals`),
        title: this.$t('global.sidebar_menu.configuration_menu.accounting-journals'),
        icon: 'pe-7s-notebook',
        exactPath: true,
        permissions: [AuthorizationHelper.fixedPermissions.sidebar.accounting_journals],
        module: ModulesHelper.ACCOUNTING_MODULE_NAME,
      },
      {
        href: this.$clientRouter.getClientUrl(`admin/configuration/accounts`),
        title: this.$t('global.sidebar_menu.configuration_menu.accounts'),
        icon: 'pe-7s-portfolio',
        exactPath: true,
        permissions: [AuthorizationHelper.fixedPermissions.sidebar.accounts],
        module: ModulesHelper.ACCOUNTING_MODULE_NAME,
      },
      {
        href: this.$clientRouter.getClientUrl(`admin/configuration/analytic-accounts`),
        title: this.$t('global.sidebar_menu.configuration_menu.analytic_accounts'),
        icon: 'pe-7s-portfolio',
        exactPath: true,
        hidden: this.hideAnalyticsSidebar,
        permissions: [AuthorizationHelper.fixedPermissions.sidebar.analytic_accounts],
        module: ModulesHelper.ACCOUNTING_MODULE_NAME,
      },
      {
        href: this.$clientRouter.getClientUrl(`admin/configuration/pos-boxes`),
        title: this.$t('global.sidebar_menu.configuration_menu.pos_boxes'),
        icon: 'pe-7s-calculator',
        exactPath: true,
        permissions: [AuthorizationHelper.fixedPermissions.sidebar.pos_boxes],
        module: ModulesHelper.POS_MODULE_NAME,
      },
      {
        href: this.$clientRouter.getClientUrl(`admin/configuration/terminals`),
        title: this.$t('global.sidebar_menu.configuration_menu.terminals'),
        icon: 'pe-7s-print',
        exactPath: true,
        permissions: [AuthorizationHelper.fixedPermissions.sidebar.terminals],
        module: ModulesHelper.PAYMENT_TERMINALS_MODULE_NAME,
      },
      {
        href: this.$clientRouter.getClientUrl(`admin/coming-soon`),
        title: this.$t('global.sidebar_menu.configuration_menu.subscription_articles'),
        hidden: this.hideMenuItem,
        icon: 'pe-7s-credit',
        exactPath: true,
      },
      {
        href: this.$clientRouter.getClientUrl(`admin/coming-soon`),
        title: this.$t('global.sidebar_menu.configuration_menu.material_articles'),
        hidden: this.hideMenuItem,
        icon: 'pe-7s-bicycle',
        exactPath: true,
      },
      {
        header: true,
        title: this.$t('global.sidebar_menu.configuration_menu.schedules_configuration'),
        permissions: ['sidebar_schedule_section'],
      },
      {
        href: this.$clientRouter.getClientUrl(`admin/configuration/holidays`),
        title: this.$t('global.sidebar_menu.configuration_menu.holidays'),
        icon: 'pe-7s-date',
        exactPath: true,
        permissions: [AuthorizationHelper.fixedPermissions.sidebar.holidays],
      },
      {
        href: this.$clientRouter.getClientUrl(`admin/configuration/slot-price-categories`),
        title: this.$t('global.sidebar_menu.configuration_menu.slot_price_categories'),
        icon: 'pe-7s-folder',
        exactPath: true,
        permissions: [AuthorizationHelper.fixedPermissions.sidebar.slot_price_categories],
        module: ModulesHelper.BOOKINGS_MODULE_NAME,
      },
      {
        href: this.$clientRouter.getClientUrl(`admin/configuration/schedules`),
        title: this.$t('global.sidebar_menu.configuration_menu.schedules'),
        icon: 'pe-7s-folder',
        exactPath: true,
        permissions: [AuthorizationHelper.fixedPermissions.sidebar.schedules],
      },
      {
        header: true,
        title: this.$t('global.sidebar_menu.configuration_menu.access_control_configuration'),
        module: ModulesHelper.ACCESS_CONTROL_MODULE_NAME,
        permissions: ['sidebar_access_control_configuration_section'],
        hidden: this.hideAccessPointsSidebar,
      },
      {
        href: this.$clientRouter.getClientUrl(`admin/configuration/access-points`),
        title: this.$t('global.sidebar_menu.configuration_menu.access_points'),
        icon: 'pe-7s-door-lock',
        exactPath: true,
        permissions: [AuthorizationHelper.fixedPermissions.sidebar.access_points],
        module: ModulesHelper.ACCESS_CONTROL_MODULE_NAME,
        hidden: this.hideAccessPointsSidebar,
      },
      {
        header: true,
        title: this.$t('global.sidebar_menu.configuration_menu.categories_and_tags'),
        modules: [
          ModulesHelper.CONTACTS_MODULE_NAME,
          ModulesHelper.BOOKINGS_MODULE_NAME,
          ModulesHelper.ACTIVITIES_MODULE_NAME,
          ModulesHelper.ACCOUNTING_MODULE_NAME,
        ],
        permissions: ['sidebar_categories_configuration_section'],
      },
      {
        href: this.$clientRouter.getClientUrl(`admin/configuration/price-categories`),
        title: this.$t('global.sidebar_menu.configuration_menu.price_categories'),
        icon: 'pe-7s-folder',
        exactPath: true,
        permissions: [AuthorizationHelper.fixedPermissions.sidebar.price_categories],
        module: ModulesHelper.CONTACTS_MODULE_NAME,
      },
      {
        href: this.$clientRouter.getClientUrl(`admin/configuration/contact-tags`),
        title: this.$t('global.sidebar_menu.configuration_menu.contact_tags'),
        icon: 'pe-7s-ticket',
        exactPath: true,
        permissions: [AuthorizationHelper.fixedPermissions.sidebar.contact_tags],
        module: ModulesHelper.CONTACTS_MODULE_NAME,
      },
      {
        href: this.$clientRouter.getClientUrl(`admin/configuration/contact-relation-categories`),
        title: this.$t('global.sidebar_menu.configuration_menu.contact_relation_categories'),
        icon: 'pe-7s-folder',
        exactPath: true,
        permissions: [AuthorizationHelper.fixedPermissions.sidebar.contact_relation_categories],
        module: ModulesHelper.CONTACTS_MODULE_NAME,
      },
      {
        href: this.$clientRouter.getClientUrl(`admin/main/activity-categories`),
        title: this.$t('global.sidebar_menu.main_menu.activity_categories'),
        icon: 'pe-7s-folder',
        exactPath: true,
        permissions: [AuthorizationHelper.fixedPermissions.sidebar.activity_categories],
        module: ModulesHelper.ACTIVITIES_MODULE_NAME,
      },
      {
        href: this.$clientRouter.getClientUrl(`admin/main/certificate-categories`),
        title: this.$t('global.sidebar_menu.main_menu.certificate_categories'),
        icon: 'pe-7s-folder',
        exactPath: true,
        permissions: [AuthorizationHelper.fixedPermissions.sidebar.certificate_categories],
        module: ModulesHelper.CERTIFICATES_MODULE_NAME,
      },
      {
        href: this.$clientRouter.getClientUrl(`admin/configuration/article-tags`),
        title: this.$t('global.sidebar_menu.configuration_menu.article_tags'),
        icon: 'pe-7s-ticket',
        exactPath: true,
        permissions: [AuthorizationHelper.fixedPermissions.sidebar.article_tags],
        module: ModulesHelper.ACCOUNTING_MODULE_NAME,
      },
      {
        header: true,
        title: this.$t('global.sidebar_menu.configuration_menu.templates_and_processes'),
        permissions: ['sidebar_template_section'],
      },
      {
        href: this.$clientRouter.getClientUrl(`admin/configuration/templates`),
        title: this.$t('global.sidebar_menu.configuration_menu.templates'),
        icon: 'pe-7s-news-paper',
        exactPath: true,
        permissions: [AuthorizationHelper.fixedPermissions.sidebar.templates],
      },
      {
        href: this.$clientRouter.getClientUrl(`admin/configuration/media`),
        title: this.$t('global.sidebar_menu.configuration_menu.media'),
        icon: 'pe-7s-file',
        exactPath: true,
        permissions: [AuthorizationHelper.fixedPermissions.sidebar.media],
      },
      {
        href: this.$clientRouter.getClientUrl(`admin/coming-soon`),
        title: this.$t('global.sidebar_menu.configuration_menu.processes'),
        hidden: this.hideMenuItem,
        icon: 'pe-7s-rocket',
        exactPath: true,
      },
      {
        header: true,
        title: this.$t('global.sidebar_menu.configuration_menu.options_and_settings'),
        permissions: ['sidebar_options_and_settings_section'],
      },
      {
        href: this.$clientRouter.getClientUrl(`admin/configuration/center-settings`),
        title: this.$t('global.sidebar_menu.configuration_menu.center_settings'),
        icon: 'pe-7s-edit',
        exactPath: true,
        permissions: [AuthorizationHelper.fixedPermissions.sidebar.center_settings],
      },
      {
        href: this.$clientRouter.getClientUrl(`admin/configuration/payment-config`),
        title: this.$t('global.sidebar_menu.configuration_menu.payment_config'),
        icon: 'pe-7s-cash',
        exactPath: true,
        permissions: [AuthorizationHelper.fixedPermissions.sidebar.center_settings],
      },
      {
        href: this.$clientRouter.getClientUrl(`admin/configuration/option-groups`),
        title: this.$t('global.sidebar_menu.configuration_menu.option_groups'),
        icon: 'pe-7s-config',
        exactPath: true,
        permissions: [AuthorizationHelper.fixedPermissions.sidebar.option_groups],
      },
      {
        href: this.$clientRouter.getClientUrl(`admin/configuration/superadmin-options`),
        title: this.$t('global.sidebar_menu.configuration_menu.superadmin_options'),
        icon: 'pe-7s-door-lock',
        exactPath: true,
        permissions: [AuthorizationHelper.fixedPermissions.sidebar.superadmin_options],
      },
      {
        href: this.$clientRouter.getClientUrl(`admin/configuration/customer-area-setting`),
        title: this.$t('global.sidebar_menu.configuration_menu.customer_area_setting'),
        icon: 'pe-7s-phone',
        exactPath: true,
        permissions: [AuthorizationHelper.fixedPermissions.sidebar.customer_area_setting],
      },
      {
        href: this.$clientRouter.getClientUrl(`admin/coming-soon`),
        title: this.$t('global.sidebar_menu.configuration_menu.pages_options'),
        hidden: this.hideMenuItem,
        icon: 'pe-7s-magic-wand',
        exactPath: true,
      },
      {
        href: this.$clientRouter.getClientUrl(`admin/coming-soon`),
        title: this.$t('global.sidebar_menu.configuration_menu.settings'),
        hidden: this.hideMenuItem,
        icon: 'pe-7s-tools',
        exactPath: true,
      },
    ];
  }
}
